import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Search4 = (props) => (
  <Icon viewBox="0 0 17.593 17.531" {...props}>
    <g>
      <defs/>
      <path d="M.722 17.56l-.698-.698 4.412-4.413c-1.177-1.327-1.915-3.054-1.915-4.968a7.517 7.517 0 0 1 7.517-7.517 7.517 7.517 0 1 1 0 15.034c-1.881 0-3.579-.715-4.898-1.857L.722 17.56zm9.423-3.647a6.417 6.417 0 1 0 .002-12.834 6.417 6.417 0 0 0-.002 12.834z"
        className="cls-1" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Search4;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Search4.js